import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import moment from "moment";
import DatePicker from "react-datepicker";
import { Card, Modal } from 'react-bootstrap';
import "react-datepicker/dist/react-datepicker.css";
import Container from 'react-bootstrap/Container';
import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router';
import { setElectricityCharges, setNewTariff, setOtherCharges, uploadNewTariff } from './dispatch';
import { useDispatch, useSelector } from 'react-redux';
import Table from 'react-bootstrap/Table'
import { fetchChargingParameterCategory, fetchChargingTypeCategory, fetchChargingNameCategory, fetchUnitCategoryOtherCharges } from '../dashboard/dispatch';

function OtherCharges(props) {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [open, setOpen] = useState(false);
  const [newTariffFormData, setnewTariffFormData] = useState({});
  const [errorsOtherChargesValue, setErrorsOtherChargesValue] = useState({});
  const [newList, setNewList] = useState([]);
  const [editTaskId, setEditTaskId] = useState(null);
  const formRef = useRef();
  // const { data } = useSelector(state => state.loginReducer);
  const data =  JSON.parse(localStorage.getItem("USER_DETAILS")); 
  const { masterValueData, electricityCharge, otherCharges } = useSelector(state => state.newTariffReducer);
  const { dashboardData, ChargingNameData, ChargingTypeData, ChargingParameterData, ChargingUnitData, editsearchData,allDropDownData } = useSelector(state => state.dashboardReducer);
  const { uploadDataNewTariff } = useSelector(state => state.newTariffReducer);
  useEffect(() => {
    console.log(editsearchData?.data?.otherCharges)
    if (newList && newList?.length != 0) {
      dispatch(setOtherCharges(newList))
    }
    if (otherCharges && otherCharges?.length != 0) {
      setNewList(otherCharges)
      setnewTariffFormData(otherCharges[0])
    } else {
      if (editsearchData?.data?.otherCharges) {
        if (editsearchData?.data?.otherCharges?.otherCharge?.length) {
          setNewList(editsearchData?.data?.otherCharges?.otherCharge)
          setnewTariffFormData(editsearchData?.data?.otherCharges?.otherCharge[0])
        } else {
          setNewList([editsearchData?.data?.otherCharges?.otherCharge])
          setnewTariffFormData(editsearchData?.data?.otherCharges?.otherCharge)
        }
      }
    }
    dispatch(fetchChargingNameCategory(data))
    dispatch(fetchChargingTypeCategory(data))
    dispatch(fetchChargingParameterCategory(data))
    dispatch(fetchUnitCategoryOtherCharges(data))
  }, [otherCharges, newList]);
  const dispatch = useDispatch();

  const displayTableChargeName = (CHARGE_ID) => {
    return ChargingNameData?.pDATASET?.map((name, index) => {
      if (name.CHARGE_ID == Number(CHARGE_ID)) {
        return name.CHARGE_NAME
      }
    })
  }

  const displayTableChargeType = (CHARGE_ID) => {
    return ChargingTypeData?.pDATASET?.map((name, index) => {
      if (name.CHARGETYPE_ID == Number(CHARGE_ID)) {
        return name.CHARGETYPE_NAME
      }
    })
  }

  const displayTableParameterData = (CHARGE_ID) => {
    return ChargingParameterData?.pDATASET?.map((name, index) => {
      if (name.PARAM_ID == Number(CHARGE_ID)) {
        return name.PARAMETER_NAME
      }
    })
  }

  const displayTableUnitData = (CHARGE_ID) => {
    return ChargingUnitData?.pDATASET?.map((name, index) => {
      if (name.ID == Number(CHARGE_ID)) {
        return name.NAME
      }
    })
  }


  const handleClose = () => {
    setShow(false);
    setOpen(true)
  };
  const handleShow = () => {
    setShow(true);
  };
  const handleChangeDate = (date, event) => {
    // setDate(date);
    console.log(moment);
    setOpen(true)
  };
  const handleClick = () => {
    // props.onClick
    console.log(props.onClick)
  }
  const handleChange = (event, param) => {
    let name = event?.target?.name;
    let value = event?.target?.value;

    if (param == 'TariffValidFrom' ||
      param == 'SeasonStarts' ||
      param == 'TariffValidTo' ||
      param == 'SeasonEnds' ||
      param == 'SpecialDaysFrom' ||
      param == 'SpecialDaysEnd') {
      name = param;
      value = event.toString();
    }
    console.log(newTariffFormData?.length)
    setnewTariffFormData(values => ({ ...values, [name]: value }))
  }
  const validateForm = () => {
    const newErrors = {};
    // if (!newTariffFormData?.ChargeName) newErrors.ChargeName = 'Charge Name is required';
    // if (!newTariffFormData?.ChargeType) newErrors.ChargeType = 'Tariff Service Type Category is required';
    // if (!newTariffFormData?.TariffFixedFCSubsidy) newErrors.TariffFixedFCSubsidy = 'Tariff Fixed Subsidy is required';
    // if (!newTariffFormData?.Subsidy) newErrors.Subsidy = 'Tariff Fixed Subsidy is required';
    // if (!newTariffFormData?.Value) newErrors.Value = 'Tariff Fixed Charges is required';
    // if (!newTariffFormData?.Unit) newErrors.Unit = 'Tariff Fixed Charges is required';
    return newErrors;
  };
  const handleSubmit = (event) => {
    // event.preventDefault();
    const formErrors = validateForm();

    if (Object.keys(formErrors).length > 0) {
      setErrorsOtherChargesValue(formErrors);
    } else {
      setErrorsOtherChargesValue({});
      addNewRecord()
      // props.onClick("#ElectricityValue")
      // dispatch(setNewTariff(newTariffFormData))
    }
  };
  const addNewRecord = () => {
    let ao = {
      ...newTariffFormData,
      key: Date.now(),
    }
    setNewList(old => [...old, ao]);
    // setnewTariffFormData('');
    // formRef.current.reset();
  }
  const updateRecord = (newTariffFormData) => {
    const updatedTasks = newList?.map(task => {
      if (task.key === editTaskId) {
        return newTariffFormData
      }
      return task;
    });
    setNewList(updatedTasks);
    setEditTaskId(null);
    formRef.current.reset();
  }
  const handleDelete = (id) => {
    setNewList(newList.filter(task => task.key !== id));
    if (editTaskId === id) {
      setEditTaskId(null);
    }
    if (newList.length == 1) {
      dispatch(setOtherCharges(null))
    }
  };
  const handleEdit = (id) => {
    const taskToEdit = newList.find(task => task.key === id);
    if (taskToEdit) {
      console.log(taskToEdit)
      setnewTariffFormData(taskToEdit)
      setEditTaskId(id);
    }
  };
  return (
    <Form onSubmit={handleSubmit} ref={formRef}>
      {
        (data?.pDATASET[0]?.STATE_NAME || data?.pDATASET[0]?.CIRCLE_NAME) ?
          <Card style={{ borderWidth: 0, height: '60px', width: '100%', backgroundColor: '#FFF6D6', borderRadius: '0px' }}>
            <Container style={{ paddingTop: '10px', }}>
              <Row>
                <Col sm={2} style={{ fontFamily: "Roboto-Light", fontSize: '13px' }}>State</Col>
                <Col sm={2} style={{ fontFamily: "Roboto-Light", fontSize: '13px' }}>Distict</Col>
                {uploadDataNewTariff?.PTARIFFID ? <Col sm={2} style={{ fontFamily: "Roboto-Light", fontSize: '13px' }}>Tariff ID</Col> : null}
              </Row>
              <Row>
                <Col sm={2} style={{ fontFamily: "Roboto-Regular ", fontSize: '15px' }}>{data?.pDATASET[0]?.STATE_NAME}</Col>
                <Col sm={2} style={{ fontFamily: "Roboto-Regular", fontSize: '15px' }}>{data?.pDATASET[0]?.CIRCLE_NAME}</Col>
                <Col sm={2} style={{ fontFamily: "Roboto-Regular ", fontSize: '15px' }}>{uploadDataNewTariff?.PTARIFFID}</Col>
              </Row> </Container> </Card> : null
      }
      <Row className="mb-3">
        <Form.Group as={Col} sm={3} controlId="ChargeName">
          <Form.Label>Charge Name</Form.Label>
          <Form.Select defaultValue="Choose..."
            name="ChargeName"
            value={newTariffFormData?.ChargeName}
            onChange={handleChange}
            isInvalid={!!errorsOtherChargesValue.ChargeName}>
            <option value="">Please select</option>Î
            {
              ChargingNameData?.pDATASET?.map((name, index) => {
                return <option value={name.CHARGE_ID}>{name.CHARGE_NAME}</option>
              })
            }
          </Form.Select>
          <Form.Control.Feedback type="invalid">
            {errorsOtherChargesValue.ChargeName}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group as={Col} sm={3} controlId="ChargeType">
          <Form.Label> Charge Type</Form.Label>
          <Form.Select defaultValue="Choose..."
            name="ChargeType"
            onChange={handleChange}
            value={newTariffFormData?.ChargeType}
            isInvalid={!!errorsOtherChargesValue.ChargeType}>
            <option value="">Please select</option>
            {
              ChargingTypeData?.pDATASET?.map((name, index) => {
                return <option value={name.CHARGETYPE_ID}>{name.CHARGETYPE_NAME}</option>
              })
            }
          </Form.Select>
          <Form.Control.Feedback type="invalid">
            {errorsOtherChargesValue.ChargeType}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group as={Col} sm={3} controlId="ChargingParameter">
          <Form.Label> Charging Parameter</Form.Label>
          <Form.Select defaultValue="Choose..."
            name="ChargingParameter"
            onChange={handleChange}
            value={newTariffFormData?.ChargingParameter}
            isInvalid={!!errorsOtherChargesValue.ChargingParameter}>
            <option value="">Please select</option>
            {
              ChargingParameterData?.pDATASET?.map((name, index) => {
                return <option value={name.PARAM_ID}>{name.PARAMETER_NAME}</option>
              })
            }
          </Form.Select>
          <Form.Control.Feedback type="invalid">
            {errorsOtherChargesValue.TariffServiceTypeCategory}
          </Form.Control.Feedback>
        </Form.Group>

      </Row>
      <Row className="mb-3">
        <Form.Group as={Col} sm={3} controlId="Charge Value ">
          <Form.Label>Charge Value</Form.Label>
          <Form.Control placeholder="Charge Value"
            onKeyPress={(event) => {
              if (!/[0-9.]/.test(event.key)) {
                event.preventDefault();
              }
            }}
            onPaste={(e) => {
              e.preventDefault()
              return false;
            }}
            value={newTariffFormData?.ChargeValue}
            name="ChargeValue"
            onChange={handleChange}
            isInvalid={!!errorsOtherChargesValue.ChargeValue} />
          <Form.Control.Feedback type="invalid">
            {errorsOtherChargesValue.ChargeValue}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group as={Col} sm={3} controlId="ChargingUnit">

          <Form.Label>Charging Unit</Form.Label>
          <Form.Select defaultValue="Choose..."
            name="ChargingUnit"
            value={newTariffFormData?.ChargingUnit}
            onChange={handleChange}
            isInvalid={!!errorsOtherChargesValue.ChargingUnit}>
            <option value="">Please select</option>Î
            {
              allDropDownData?.pDATASET?.map((item, index) => {
                if (item.TYPE == 'OCUNIT')
                  return <option value={item.ID}>{item.NAME}</option>
              })
            }
          </Form.Select>
          <Form.Control.Feedback type="invalid">
            {errorsOtherChargesValue.ChargingUnit}
          </Form.Control.Feedback>
        </Form.Group>
      </Row>
      <div style={{ marginTop: 40, marginLeft: '10px' }}>
        <Button variant="primary" disabled={editTaskId == null ? false : true} style={{ marginLeft: 15 }} onClick={() => { handleSubmit() }}>
          ADD NEW
        </Button>
        <Button disabled={editTaskId !== null ? false : true} variant="primary" style={{ marginLeft: 15 }} onClick={() => { updateRecord(newTariffFormData) }}>
          Update
        </Button>
        {
          (newList && newList?.length != 0) ?
            <Button variant="primary" style={{ marginLeft: 15 }}
              onClick={() => {
                props.onClick("#OtherValuePreview")
                if (newList && newList?.length != 0) {
                  let newListArr = [];
                  newList && newList?.map((data, i) => {
                    data["RowId"] = i + 1;
                    newListArr.push(data)
                  })
                  setNewList(newListArr);
                }
                if (newList && newList?.length != 0) {
                  dispatch(setOtherCharges(newList))
                }
              }}
            >
              Preview
            </Button> : null
        }
        {/* <Button variant="primary" style={{ marginLeft: 15 }}
          onClick={() => {
            // dispatch(setOtherCharges(newList))
            // let masterValue = { masterValueData, electricityCharge, otherCharges }
            // let userData = { masterValue: masterValue, data: data, id: editsearchData?.data?.masterValueData?.TariffId }
            // dispatch(uploadNewTariff(userData))
          }}
        >
          Submit
        </Button> */}

      </div>
      <div style={{ marginTop: 10 }}>
        {
          (newList && newList?.length != 0) ? <Table class="table table-striped table-light">
            <thead>
              <tr>
                <th style={{ backgroundColor: '#FFF6D6' }} width="100">Charge Name  </th>
                <th style={{ backgroundColor: '#FFF6D6' }} width="200">Charge Type</th>
                <th style={{ backgroundColor: '#FFF6D6' }} width="200">Charging Parameter</th>
                <th style={{ backgroundColor: '#FFF6D6' }} width="100">Charging Unit</th>
                <th style={{ backgroundColor: '#FFF6D6' }} width="50">Charge Value</th>
                <th style={{ backgroundColor: '#FFF6D6' }} width="50"></th>
                <th style={{ backgroundColor: '#FFF6D6' }} width="50"></th>
              </tr>
            </thead>
            <tbody>
              {newList && newList?.map((listValue, index) => {
                return (
                  <tr key={index}>
                    <td>{displayTableChargeName(listValue?.ChargeName)}{listValue?.ChargeName}</td>
                    <td>{displayTableChargeType(listValue?.ChargeType)}</td>
                    <td>{displayTableParameterData(listValue?.ChargingParameter)}</td>
                    <td>{displayTableUnitData(listValue?.ChargingUnit)}</td>
                    <th scope="row">{listValue?.ChargeValue}</th>
                    <td>{<Button variant="primary" onClick={() => handleEdit(listValue?.key)}>Edit </Button>}</td>
                    <td>{<Button variant="primary" onClick={() => handleDelete(listValue?.key)}>Delete </Button>}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
            : null
        }
      </div>
    </Form>
  );
}

export default OtherCharges;